import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../../components/layout/AuthLayout.jsx';
import { PasswordField } from '../../components/forms/PasswordField.jsx';
import { api } from '../../api/client.js';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  async function submit(event) {
    event.preventDefault(); setBusy(true); setError(''); setMessage('');
    try {
      const result = await api.post('/api/tenant-admin/auth/forgot-password', { email });
      setMessage(result.message);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <AuthLayout title="Reset your password." description="We’ll send a secure reset link if the email belongs to an active account." role="Restaurant admin" footer={<Link to="/login">Back to sign in</Link>}>
    {error && <div className="alert alert-error" role="alert">{error}</div>}
    {message ? <div className="alert alert-success" role="status">{message}</div> : <form onSubmit={submit}><div className="field"><label htmlFor="reset-email">Email</label><input id="reset-email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} /></div><button className="btn btn-primary auth-submit" disabled={busy}>{busy ? 'Sending…' : 'Send reset link'}</button></form>}
  </AuthLayout>;
}

export function SetPasswordPage() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  async function submit(event) {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const result = await api.post('/api/tenant-admin/auth/set-password', { token: params.get('token'), password });
      setMessage(result.message);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <AuthLayout title="Choose a password." description="Use at least 8 characters. Your link can only be used once." role="Restaurant admin" footer={<Link to="/login">Back to sign in</Link>}>
    {error && <div className="alert alert-error" role="alert">{error}</div>}
    {message ? <div className="alert alert-success" role="status">{message} <Link to="/login">Sign in</Link></div> : <form onSubmit={submit}><PasswordField id="new-password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={8} autoComplete="new-password" /><button className="btn btn-primary auth-submit" disabled={busy || !params.get('token')}>{busy ? 'Saving…' : 'Save password'}</button></form>}
  </AuthLayout>;
}
